(function () {
  'use strict';

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '');
  }

  function fileKey(value) {
    if (!value) return '';
    try {
      var url = new URL(value, window.location.origin);
      return normalize(decodeURIComponent(url.pathname.split('/').pop() || ''));
    } catch (error) {
      return normalize(value);
    }
  }

  function initVariantGallery(root) {
    var variantNode = root.querySelector('[data-product-variants]');
    var track = root.querySelector('[data-wc-media-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-wc-media-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-media-index]'));
    if (!variantNode || !track || !slides.length) return;

    var variants = [];
    try { variants = JSON.parse(variantNode.textContent || '[]'); } catch (error) { return; }

    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
    var colorGroup = groups.find(function (group) {
      var label = group.querySelector('.wc-product-option__label');
      var text = normalize(label ? label.textContent.split(':')[0] : '');
      return text === 'farbe' || text === 'color' || text === 'colour';
    });
    if (!colorGroup) return;

    var colorButtons = Array.prototype.slice.call(colorGroup.querySelectorAll('.wc-option-button'));
    var colorValues = colorButtons.map(function (button) {
      return { value: button.dataset.optionValue || button.textContent.trim(), key: normalize(button.dataset.optionValue || button.textContent) };
    }).filter(function (item) { return item.key; });
    if (!colorValues.length) return;

    var media = slides.map(function (slide, index) {
      var image = slide.querySelector('img');
      var thumbImage = thumbs[index] ? thumbs[index].querySelector('img') : null;
      var descriptor = normalize([
        image ? image.getAttribute('alt') : '',
        image ? image.currentSrc : '',
        image ? image.getAttribute('src') : '',
        thumbImage ? thumbImage.getAttribute('alt') : '',
        thumbImage ? thumbImage.currentSrc : '',
        thumbImage ? thumbImage.getAttribute('src') : ''
      ].join(' '));
      var filename = fileKey(image ? (image.currentSrc || image.getAttribute('src')) : '');
      var recognized = colorValues.filter(function (color) {
        return descriptor.indexOf(color.key) !== -1 || filename.indexOf(color.key) !== -1;
      }).map(function (color) { return color.key; });
      return { slide: slide, thumb: thumbs[index] || null, index: index, descriptor: descriptor, filename: filename, colors: recognized };
    });

    function selectedOptions() {
      var selected = [];
      groups.forEach(function (group) {
        var button = group.querySelector('.wc-option-button.is-selected');
        selected[Number(group.dataset.optionIndex)] = button ? button.dataset.optionValue : '';
      });
      return selected;
    }

    function selectedVariant() {
      var selected = selectedOptions();
      return variants.find(function (variant) {
        return variant.options && variant.options.every(function (value, index) { return value === selected[index]; });
      }) || null;
    }

    function featuredMediaIndex(variant) {
      if (!variant || !variant.featured_image) return -1;
      var featuredKey = fileKey(variant.featured_image.src || variant.featured_image.url || '');
      if (!featuredKey) return -1;
      return media.findIndex(function (item) {
        return item.filename && (item.filename === featuredKey || item.filename.indexOf(featuredKey) !== -1 || featuredKey.indexOf(item.filename) !== -1);
      });
    }

    function setActive(index) {
      thumbs.forEach(function (thumb, thumbIndex) {
        thumb.classList.toggle('is-active', thumbIndex === index && !thumb.hidden);
      });
    }

    function focusMedia(index, smooth) {
      var item = media[index];
      if (!item || item.slide.hidden) return;
      var left = item.slide.offsetLeft;
      if (typeof track.scrollTo === 'function') {
        track.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
      } else {
        track.scrollLeft = left;
      }
      setActive(index);
    }

    function applyGallery(smooth) {
      var activeColor = colorGroup.querySelector('.wc-option-button.is-selected');
      if (!activeColor) return;
      var selectedColor = normalize(activeColor.dataset.optionValue || activeColor.textContent);
      if (!selectedColor) return;

      var variant = selectedVariant();
      var featuredIndex = featuredMediaIndex(variant);
      var specific = media.filter(function (item) { return item.colors.indexOf(selectedColor) !== -1; });
      var recognizedCount = media.filter(function (item) { return item.colors.length > 0; }).length;

      if (specific.length > 0) {
        media.forEach(function (item) {
          var isSelectedColor = item.colors.indexOf(selectedColor) !== -1;
          var isShared = item.colors.length === 0;
          var show = isSelectedColor || isShared;
          item.slide.hidden = !show;
          if (item.thumb) item.thumb.hidden = !show;
        });
      } else {
        media.forEach(function (item) {
          item.slide.hidden = false;
          if (item.thumb) item.thumb.hidden = false;
        });
      }

      var preferred = -1;
      if (featuredIndex >= 0 && !media[featuredIndex].slide.hidden) preferred = featuredIndex;
      if (preferred < 0 && specific.length > 0) preferred = specific[0].index;
      if (preferred < 0 && recognizedCount > 0) {
        preferred = media.findIndex(function (item) { return !item.slide.hidden; });
      }
      if (preferred < 0) preferred = featuredIndex >= 0 ? featuredIndex : 0;
      focusMedia(preferred, smooth);
    }

    colorButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { applyGallery(true); });
        });
      });
    });

    track.addEventListener('scroll', function () {
      var visible = media.filter(function (item) { return !item.slide.hidden; });
      if (!visible.length) return;
      var closest = visible.reduce(function (best, item) {
        return Math.abs(item.slide.offsetLeft - track.scrollLeft) < Math.abs(best.slide.offsetLeft - track.scrollLeft) ? item : best;
      }, visible[0]);
      setActive(closest.index);
    }, { passive: true });

    applyGallery(false);
  }

  function init() {
    document.querySelectorAll('[data-wc-product]').forEach(initVariantGallery);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
